const tokens = {
  origin: {
    en: 'from',
    de: 'von',
    es: 'de',
  },
  destination: {
    en: 'to',
    de: 'nach',
    es: 'a',
  },
};
const wordAfter = (keyword) => (word, index, words) => words[index - 1] === keyword;

export default (query, locale) => {
  const words = query.split(' ');
  const originToken = tokens.origin[locale];
  const destinationToken = tokens.destination[locale];
  const origin = words.find(wordAfter(originToken));
  const destination = words.find(wordAfter(destinationToken));
  return { origin, destination };
};
